module.exports = __webpack_public_path__ + "assets/otocephaly.f6a064ce.png";